/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ExternalItemListHeader_data = {
    readonly sortKeys: ReadonlyArray<{
        readonly key: string;
        readonly title: string;
    }>;
    readonly filters: ReadonlyArray<{
        readonly key: string;
        readonly name: string | null;
        readonly values: ReadonlyArray<{
            readonly label: string;
            readonly displayLabel: string;
            readonly selected: boolean;
            readonly count: string;
        }> | null;
    }>;
    readonly totalCount: number | null;
    readonly downloadToken: string;
    readonly " $refType": "ExternalItemListHeader_data";
};
export type ExternalItemListHeader_data$data = ExternalItemListHeader_data;
export type ExternalItemListHeader_data$key = {
    readonly " $data"?: ExternalItemListHeader_data$data;
    readonly " $fragmentRefs": FragmentRefs<"ExternalItemListHeader_data">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExternalItemListHeader_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SortKey",
      "kind": "LinkedField",
      "name": "sortKeys",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Filter",
      "kind": "LinkedField",
      "name": "filters",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FilterValue",
          "kind": "LinkedField",
          "name": "values",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayLabel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "selected",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadToken",
      "storageKey": null
    }
  ],
  "type": "ExternalItemList",
  "abstractKey": null
};
})();
(node as any).hash = '1162be85e28177eba03ae61ce5ac049c';
export default node;
